import { ChangeEvent, Dispatch, SetStateAction, useCallback } from 'react'

const useHandleStatus = (
  isEditPage: boolean,
  setStatus: Dispatch<SetStateAction<string>>,
  openStatusChangeCautionModal: () => void
): ((event: ChangeEvent<HTMLInputElement>) => void) => {
  return useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value
      if (value === 'private' && isEditPage) {
        openStatusChangeCautionModal()
      } else {
        setStatus(value)
      }
    },
    [setStatus, isEditPage]
  )
}

export default useHandleStatus
